import * as React from 'react'

export const ForgetPasswordDesktop = () => {
	return (
		<>
			<div className="forgot-password-container desktop-forget-password">
				<a href="/users/passwordRecovery" className="forget-password-h">
					Forgot Password?
				</a>
				<div>
					<p className="forget-password-p">Don’t have a Readpeak account yet?</p>
					<a href="/signup" className="forget-password-l">
						Create one here
					</a>
				</div>
			</div>
		</>
	)
}

export const ForgetPasswordMobile = () => {
	return (
		<>
			<div className="mobile-forget-password">
				<a href="/users/passwordRecovery" className="forget-password-h">
					Forgot Password?
				</a>
				<div>
					<p className="forget-password-p">Don’t have a Readpeak account yet?</p>
					<a href="/signup" className="forget-password-l">
						Create one here
					</a>
				</div>
			</div>
		</>
	)
}
